/**
 * Shared with ChatVehicleCard.vue, ChatVehicleCandidates.vue and ChatApp.vue's
 * chooseVehicleCandidate() - a resolved vehicle and a not-yet-chosen candidate are described the
 * same way everywhere in the chat, just with a different fallback for "nothing to show yet".
 */
export function vehicleTitle(vehicle: Record<string, any>, fallback = ''): string {
    return [vehicle.carBrandName, vehicle.modelName, vehicle.typeName].filter(Boolean).join(' ') || fallback;
}

/**
 * The design's example line reads "1.6 TDI · 2015 · 81 kW (110 pk) · Hatchback". Everything but the
 * build year is in the car API's response; there is no year field, so the year is simply absent
 * rather than guessed at. The car API's kw field is not a bare number (e.g. "75kW") - confirmed
 * against a live VIN lookup - so parseFloat pulls the numeric part out rather than assuming a clean
 * number.
 */
export function vehicleSpecs(vehicle: Record<string, any>): string {
    const kw = parseFloat(vehicle.kw);

    return [vehicle.engineType, Number.isFinite(kw) ? `${kw} kW (${Math.round(kw * 1.36)} pk)` : null, vehicle.bodyType]
        .filter(Boolean)
        .join(' · ');
}
